import { render, staticRenderFns } from "./LevelSelectionStep.vue?vue&type=template&id=c52b33e8&scoped=true&"
import script from "./LevelSelectionStep.vue?vue&type=script&lang=js&"
export * from "./LevelSelectionStep.vue?vue&type=script&lang=js&"
import style0 from "./LevelSelectionStep.vue?vue&type=style&index=0&id=c52b33e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52b33e8",
  null
  
)

export default component.exports